import ExhibitionStands from "./exhibition-stands";

export default ExhibitionStands;